export default {
  statusPendingTarget: 'Awaiting colleague',
  statusPendingManager: 'Awaiting approval',
  statusApproved: 'Approved',
  statusRejected: 'Rejected',
  statusCancelled: 'Cancelled',
  statusExpired: 'Expired',
  rejectTitle: 'Reject swap request',
  reason: 'Reason',
  reasonHint: 'Optional — shown to both employees.',
  rejectedToast: 'Swap request rejected.',
  rejecting: 'Rejecting…',
  reject: 'Reject',
  givingAway: 'Giving away <give></give>',
  givingAwayExchange: 'Giving away <give></give> in exchange for <take></take>',
  note: 'Note: {note}',
  approvedToast: 'Swap approved.',
  approving: 'Approving…',
  approve: 'Approve',
  title: 'Swap requests',
  description: 'Shift swaps awaiting your approval, plus their history.',
  requests: 'Requests',
  filterByStatus: 'Filter by status',
  allStatuses: 'All statuses',
  empty: 'No swap requests here.',
}
